export default "__VITE_ASSET__C7dDR$wn__"